import { AsyncRequest } from 'angieslist-app-platform';

export default {
  ...AsyncRequest.createActionKeys('CREATE_ACCOUNT'),
  ...AsyncRequest.createActionKeys('GET_USER_MATCHES'),
  ...AsyncRequest.createActionKeys('LINK_ACCOUNTS'),
  ...AsyncRequest.createActionKeys('LINK_BUSINESS'),

};



// WEBPACK FOOTER //
// ./src/modules/sync/common/accountSyncActionKeys.js